import { fmtDateTime } from "../../../Utils/dateFormat";
import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import apiService from "../../../Services/authenticationServices";
import { useCheOrders } from "./CheOrders";
import { useWarehouse } from "../../Layout/WarehouseContext";
import { toast } from "react-toastify";
import { convertUTCDate, convertFormat, getPrescriptionSrcType } from "../../../Utils/utilServices";
import bulkOrderIcon from '../../../Assets/BulkOrder.png'

const PrescriptionItem = ({ item, index }) => {

  const [currentUrl, setCurrentUrl] = useState(item.fallbackUrl ? null : item.url);
  const [isLoading, setIsLoading] = useState(!!item.fallbackUrl);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    if (!item.fallbackUrl) {
      setCurrentUrl(item.url);
      setIsLoading(false);
      return;
    }

    const checkUrl = async (url) => {
      try {
        const response = await fetch(url, { method: 'GET' });
        if (response.ok) {
          const contentType = response.headers.get('content-type');
          if (contentType && !contentType.includes('xml')) {
            return true;
          }
        }
        return false;
      } catch {
        return false;
      }
    };

    const determineUrl = async () => {
      const primaryWorks = await checkUrl(item.url);
      if (primaryWorks) {
        setCurrentUrl(item.url);
      } else {
        const fallbackWorks = await checkUrl(item.fallbackUrl);
        if (fallbackWorks) {
          setCurrentUrl(item.fallbackUrl);
        } else {
          setHasError(true);
        }
      }
      setIsLoading(false);
    };

    determineUrl();
  }, [item.url, item.fallbackUrl]);

  const handleImageError = () => {
    if (item.fallbackUrl && currentUrl !== item.fallbackUrl) {
      setCurrentUrl(item.fallbackUrl);
    } else {
      setHasError(true);
    }
  };

  if (isLoading) {
    return (
      <div className="border rounded p-2 flex items-center justify-center h-[200px]">
        <p>Loading prescription...</p>
      </div>
    );
  }

  if (hasError || !currentUrl) {
    return (
      <div className="border rounded p-2 flex items-center justify-center h-[200px]">
        <p>Failed to load prescription</p>
      </div>
    );
  }

  return (
    <div className="border rounded p-2">
      {item.srcType.includes("image/") ? (
        <img
          src={item.url}
          alt={`Prescription ${index + 1}`}
          className="w-full h-auto mx-auto"
        />
      ) : (
        <iframe
          src={item.url}
          className="w-full h-[500px]"
          title={`Prescription ${index + 1}`}
        ></iframe>
      )}
    </div>
  );
};

const OrderHeaderAccordion = ({ data, index, isOpen, onToggle, onClose }) => {
  const scrollRef = useRef(null);
  const bgColor = index % 2 === 0 ? "bg-[#f6f5f1]" : "bg-[#FFFFFF]";
  const [orderDetails, setorderDetails] = useState([]);
  const [enquiryId, setenquiryId] = useState(data.id);
  const [showPrescription, setShowPrescription] = useState(false);
  const [prescriptionUrls, setPrescriptionUrls] = useState([]);
  const [showInvalidConfirm, setShowInvalidConfirm] = useState(false);
  const [view, setview] = useState(false);
  const [showTransferPopup, setShowTransferPopup] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState(data.hospitalId);
  const [warehouseList, setwarehouseList] = useState([]);
  const drefaultWarehouse = data.hospitalId;

  const slaList = [
    { name: "0 -12 Hours", value: 1 },
    { name: "12-24 Hours", value: 2 },
    { name: "24-36 Hours", value: 3 },
    { name: "36-48 Hours", value: 4 },
    { name: "48-60 Hours", value: 5 },
    { name: "60-72 Hours", value: 6 },
    { name: "72 Hrs-1 Week", value: 7 },
    { name: "Cannot be supplied", value: 8 },
    { name: "CureBay Preferred Medicine ", value: 9 },
  ];

  const columns = [
    { field: "drugName", header: "Drug Name" },
    { field: "drugCode", header: "Drug Code" },
    { field: "drugsInfoComposition", header: "Composition & Strength" },
    { field: "drugsInfoTypeofsell", header: "Package Size" },
    { field: "quantity", header: "Quantity" },
    { field: "unitPrice", header: "Unit Price" },
    { field: "actualPrice", header: "Payable Amount" },
    { field: "deliverySlaStatus", header: "SLA" },
    { field: "deliverySlaTime", header: "Committed ETA" },
    { field: "deliverySlaETATime", header: "ETA" },
  ];

  const formatAddress = (...parts) => parts.filter(Boolean).join(", ");

  const fetchData = async () => {
    try {
      const payload = {
        patientDrugPrescriptionOrderId: data.orderId,
        status: 1,
      };

      const response = await apiService.getOrderDetails(payload);
      const enquiryList = response.data.successList;
      setorderDetails(enquiryList);
    } catch (err) {
      console.error("Error fetching order details:", err);
    }
  };
  const wareHouseData = async () => {
    try {
      const response = await apiService.getwareHouseDetails();
      const res = response.data.successList;
      console.log(res);
      setwarehouseList(res);
    } catch (err) {
      console.error("Error fetching order details:", err);
    }
  };

  const getSlaName = (value) => {
    const slaItem = slaList.find((item) => item.value === value || "");
    return slaItem?.name ?? "";
  };

  const viewPrescription = async (orderData) => {
    setview(true);
    const urls = [];
    const buildLegacyEntry = (file) => {
      const extension = file.split(".").pop().toUpperCase();
      const primaryUrl = process.env.REACT_APP_API_GCP_URL + "curebay-prescription-docs/" + file;
      const fallbackUrl = process.env.REACT_APP_API_GCP_URL + file;

      switch (extension) {
        case "PDF":
          return { url: primaryUrl, fallbackUrl, srcType: "application/pdf" };
        case "JPG":
          return { url: primaryUrl, fallbackUrl, srcType: "image/jpg" };
        case "JPEG":
          return { url: primaryUrl, fallbackUrl, srcType: "image/jpeg" };
        case "PNG":
          return { url: primaryUrl, fallbackUrl, srcType: "image/png" };
        default:
          return { url: primaryUrl, fallbackUrl, srcType: "application/octet-stream" };
      }
    };

    const processFiles = async (filesStr) => {
      if (!filesStr) return;
      const files = filesStr.split(",");

      const filePromises = files.map(async (file) => {
        if (!file) return;
        const response = await apiService.getDocumentUrl(file);
        if (response?.status === 200 && response?.data?.SIGNED_URL) {
          urls.push({ url: response.data.SIGNED_URL, srcType: getPrescriptionSrcType(file) });
        } else {
          console.warn("getDocumentUrl failed (500 or otherwise), falling back to the old REACT_APP_API_GCP_URL behavior for", file, response);
          urls.push(buildLegacyEntry(file));
        }
      });

      await Promise.all(filePromises);
    };

    await processFiles(orderData.prescriptionDoc);
    if (orderDetails.length > 0) {
      await processFiles(orderDetails[0].prescriptionUrl);
    }

    if (urls.length > 0) {
      setPrescriptionUrls(urls);
      setShowPrescription(true);
    } else {
      toast.error("No prescription available for this order");
    }
  };


  const isMedsNow = (data.shipments || []).some(
    (sh) => sh?.shipmentType === "EXPRESS_30"
  );

  const headerFields = [
    { label: "Order Date", value: fmtDateTime(data.modifiedDate), width: "sm:w-[12%]" },
    { label: "Order ID", value: data.orderId, width: "sm:w-[12%]" },
    { label: "Patient ID", value: data.patientId, width: "sm:w-[12%]" },
    { label: "Patient Name", value: data.patientName, width: "sm:w-[12%]" },
    { label: "Mobile No.", value: data.patientMobile, width: "sm:w-[12%]" },
    {
      label: "Patient Address",
      value: formatAddress(data.address1, data.address2, data.address3),
      width: "sm:w-[20%]",
    },
    { label: "Eclinic", value: data.cheBranchName, width: "sm:w-[10%]" },
    {
      label: "Eclinic Address",
      value: formatAddress(
        data.deliveryAddress1,
        data.deliveryAddress2,
        data.deliveryAddress3
      ),
      width: "sm:w-[20%]",
    },
    { label: "Amount", value: data.paidAmount, width: "sm:w-[8%]" },
  ];

  const submitOrder = async (e) => {
    try {
      let payload = {};
      e === "C"
        ? (payload = {
          orderId: data.orderId,
          procedureStatus: 1,
          status: data.status,
        })
        : (payload = {
          orderId: data.orderId,
          procedureStatus: 0,
          status: 8,
        });

      const res = await apiService.submitorderDetails(payload);
      if (res.data.responseCode === '200') {
        toast.success(e === 'C' ? 'Order Submitted Successfully' : 'Order Updated Successfully');
        onClose();
        setShowInvalidConfirm(false);
      }
      setview(false);
    } catch (err) {
      console.error(err);
      toast.error("Failed to submit order");
    }
  };

  const handleTransferOrder = async () => {
    if (!selectedWarehouse) {
      toast.error("Please select a warehouse");
      return;
    }
    if (drefaultWarehouse === selectedWarehouse) {
      const pharmacyName = warehouseList.find(
        (item) => item.pharmacyCode === selectedWarehouse
      )?.pharmacyName;
      toast.error(
        `Please select a different warehouse. This order is already in ${pharmacyName} warehouse.`
      );
      return;
    }

    try {
      const payload = {
        orderId: data.orderId,
        hospitalId: selectedWarehouse,
        locationId: warehouseList.find(
          (item) => item.pharmacyCode === selectedWarehouse
        )?.locationCode,
      };

      const response = await apiService.transferOrder(payload);
      if (response.data.responseCode === "200") {
        toast.success(response.data.successObject.message);
        setShowTransferPopup(false);
        onClose();
      } else {
        toast.error(
          response.data.responseMessage || "Failed to transfer order"
        );
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while transferring the order");
    }
  };

  useEffect(() => {
    setview(false);

    if (isOpen) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      fetchData();
      wareHouseData();

      if (data.drugCategoryStatus && !data.prescriptionDoc) {
        setview(true);
      }
    }
  }, [isOpen, data.orderId]);

  useEffect(() => {
    if (!isOpen) {
      setShowPrescription(false);
      setShowInvalidConfirm(false);
      setShowTransferPopup(false);
      setview(false);
      setPrescriptionUrls([]);
    }
  }, [isOpen]);
  return (
    <div ref={scrollRef} className={`relative border rounded ${bgColor} my-3`}>
      {isMedsNow && (
        <span className="absolute top-0 left-0 z-10 px-2 py-0.5 rounded-tl rounded-br bg-[#336b3b] text-white text-[10px] font-bold tracking-wide">
          MEDS NOW
        </span>
      )}

      <div
        onClick={onToggle}
        className="cursor-pointer px-2 sm:px-4 flex justify-between items-center"
      >
        <div className={`flex-1 min-w-0 p-2 sm:p-4 ${isMedsNow ? "pt-6 sm:pt-6" : ""}`}>
          <div className="flex flex-wrap sm:flex-nowrap overflow-auto text-xs gap-x-3 gap-y-2 sm:gap-5">
            {headerFields.map(({ label, value, width }, i) => (
              <span key={i} className={`w-[calc(50%-6px)] ${width} break-words`}>
                <span className="text-gray-500">{label}:</span> {value}
              </span>
            ))}
          </div>
        </div>
        <span className="text-gray-600 text-xl">
          {isOpen ? <HiChevronUp /> : <HiChevronDown />}
        </span>
      </div>

      {isOpen && <div className="h-[1px] bg-gray-300 w-full" />}

      {isOpen && (
        <div className="p-4 pb-8 bg-white overflow-auto">
          {isMedsNow && (
            <div className="mb-3">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-[#336b3b] text-white text-[11px] font-bold tracking-wide">
                <span className="h-1.5 w-1.5 rounded-full bg-white" />
                MEDS NOW
              </span>
            </div>
          )}
          <div className="flex flex-wrap sm:flex-nowrap overflow-auto gap-4 mb-4 text-sm">
            {data.defaultSla && (
              <div className="w-full sm:w-[15%] break-words">
                <p className="text-gray-500">
                  Delivery SLA: <span>{getSlaName(data.defaultSla)}</span>
                </p>
              </div>
            )}
            {data.shipTo && (
              <div className="w-full sm:w-[15%] break-words">
                <p className="text-gray-500">
                  Ship To: <span>{data.shipTo}</span>
                </p>
              </div>
            )}
            {data.shippingName && (
              <div className="w-full sm:w-[20%] break-words">
                <p className="text-gray-500">
                  Shipping Name: <span>{data.shippingName}</span>
                </p>
              </div>
            )}
            {data.shippingAddress && (
              <div className="w-full sm:w-[50%] break-words">
                <p className="text-gray-500">
                  Shipping Address: <span>{data.shippingAddress}</span>
                </p>
              </div>
            )}
          </div>

          <div className="flex flex-wrap justify-between gap-2 mb-3">
            <div>
              {(!data.prescriptionDoc || view) && (
                <button
                  className="bg-[#336b3b] text-white px-4 py-2 rounded-md mr-2"
                  onClick={() => submitOrder("C")}
                >
                  Submit
                </button>
              )}
              {data.prescriptionDoc && (
                <>
                  <button
                    className="bg-blue-500 text-white px-4 py-2 rounded-md mr-2"
                    onClick={() => viewPrescription(data)}
                  >
                    View Prescription
                  </button>
                </>
              )}
              <button
                className="bg-[#5841a0] text-white px-4 py-2 rounded-md mr-2 hover:bg-purple-600"
                onClick={() => setShowTransferPopup(true)}
              >
                Transfer
              </button>
            </div>
            <div>
              {data.bulkOrderFlag === "Y" ? (
                <div className="flex items-center text-[#2e4373] font-medium">
                  <img
                    src={bulkOrderIcon}
                    alt="Bulk Order Icon"
                    className="h-6 w-6 mr-1"
                  />
                  Marked as Bulk Order
                </div>
              ) : (
                view && (
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded-md"
                    onClick={() => setShowInvalidConfirm(true)}
                  >
                    Invalid Prescription
                  </button>
                )
              )}
            </div>
          </div>

          {showPrescription && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-0">
              <div className="bg-white p-4 rounded-lg max-w-4xl w-full max-h-screen overflow-auto">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Prescription</h2>
                  <button
                    onClick={() => setShowPrescription(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <div className="grid grid-cols-1 gap-4">
                  {prescriptionUrls.map((item, index) => (
                    <PrescriptionItem key={index} item={item} index={index} />
                  ))}
                </div>
              </div>
            </div>
          )}

          {showInvalidConfirm && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-0">
              <div className="bg-white p-6 rounded-lg max-w-md w-full">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Confirm Action</h2>
                  <button
                    onClick={() => setShowInvalidConfirm(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                <p className="mb-6">
                  Are you sure you want to mark this prescription as invalid?
                </p>

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowInvalidConfirm(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => submitOrder("I")}
                    className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                  >
                    Agree
                  </button>
                </div>
              </div>
            </div>
          )}

          {showTransferPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-0">
              <div className="bg-white p-6 rounded-lg max-w-md w-full">
                <div className="flex justify-between items-center mb-4">
                  <h2 className="text-xl font-bold">Transfer Order</h2>
                  <button
                    onClick={() => setShowTransferPopup(false)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {warehouseList && (
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Select Warehouse
                    </label>
                    <select
                      value={selectedWarehouse}
                      onChange={(e) => setSelectedWarehouse(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md"
                    >
                      <option value="">Select a warehouse</option>
                      {warehouseList?.map((warehouse) => (
                        <option
                          key={warehouse.pharmacyCode}
                          value={warehouse.pharmacyCode}
                        >
                          {warehouse.pharmacyName}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => setShowTransferPopup(false)}
                    className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleTransferOrder}
                    className="px-4 py-2 bg-[#5841a0] text-white rounded-md hover:bg-purple-600"
                  >
                    Confirm Transfer
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="overflow-x-auto border border-[#1d2f5b] rounded-md">
            <div className="min-w-full inline-block align-middle">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                  <thead className="bg-[#1d2f5b] text-white">
                    <tr>
                      {columns.map((column, index) => (
                        <th key={index} className="p-2 font-semibold">
                          {column.header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.map((item) => (
                      <tr key={item.id} className="border-t">
                        {columns.map((column) => {
                          if (column.field === "deliverySlaStatus") {
                            return (
                              <td
                                key={column.field}
                                className="p-2 whitespace-nowrap"
                              >
                                {getSlaName(
                                  item.deliverySlaStatus ?? item.defaultSla
                                )}
                              </td>
                            );
                          }
                          if (column.field === "deliverySlaETATime") {
                            const slaColor =
                              item.deliverySlaColourStatus === 2
                                ? "green"
                                : item.deliverySlaColourStatus === 1
                                  ? "red"
                                  : "";

                            const style = {
                              color: slaColor,
                              fontWeight: "bold",
                            };

                            return (
                              <td
                                key={column.field}
                                className="p-2 whitespace-nowrap"
                                style={style}
                              >
                                {item[column.field]}
                              </td>
                            );
                          }
                          return (
                            <td key={column.field} className="p-2">
                              {item[column.field] ?? "-"}
                            </td>
                          );
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const CheReceived = forwardRef((props, ref) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [orders, setOrders] = useState([]);
  const [sortOrder, setSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(true);
  const { filter, setFilterField } = useCheOrders();

  const { code: whCode } = useWarehouse();

  /* Only the latest list request may update the screen — an older, slower one
     finishing last would otherwise show results for filters no longer set. */
  const latestFetch = useRef(0);
  const fetchData = async (pageNo = 1) => {
    const seq = ++latestFetch.current;
    try {
      let payload;

      if (sortOrder === 2) {
        payload = {
          type: "invalid",
          pageNumber: pageNo,
          orderBy: "DESC",
          state: filter.state || "OD",
          circleCode: filter.circleCode || "",
          ...Object.fromEntries(
            Object.entries(filter).filter(
              ([key, val]) =>
                !["circleCode", "state"].includes(key) &&
                val !== null &&
                val !== undefined &&
                val !== ""
            )
          ),
        };
      } else {
        payload = {
          procedureStatus: 0,
          pageNumber: pageNo,
          orderBy: sortOrder === 1 ? "DESC" : "ASC",
          ...Object.fromEntries(
            Object.entries(filter).filter(
              ([_, val]) => val !== null && val !== undefined && val !== ""
            )
          ),
        };
        payload.status = 1;
      }

      /* Either date alone is a valid filter (the API treats it as that one day),
         so convert each one that is set, not only a complete range. */
      if (payload.fromDate) payload.fromDate = convertFormat(payload.fromDate);
      if (payload.toDate) payload.toDate = convertFormat(payload.toDate);

      const response = await apiService.getmedicineOrders(payload);
      if (seq !== latestFetch.current) return;
      let orderList = response.data.successList || [];

      setOrders(orderList);
      setCurrentPage(pageNo);
      setHasNextPage(orderList.length > 0);
    } catch (err) {
      if (seq !== latestFetch.current) return;
      console.error("Failed to fetch orders", err);
      setOrders([]);
      setHasNextPage(false);
    }
  };

  const handleNextPage = () => {
    fetchData(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      fetchData(currentPage - 1);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, [filter, sortOrder, whCode]);

  useImperativeHandle(ref, () => ({
    onSearch: () => fetchData(1),
  }));

  const handleToggle = (index) => {
    if (sortOrder != 2) {
      setOpenIndex((prev) => (prev === index ? null : index));
    } else {
      toast.error(
        "This order has an invalid prescription. The clinic staff will attach a new prescription"
      );
    }
  };

  const handleSortChange = (value) => {
    if (value == 2) {
      setOpenIndex(null);
    }
    setSortOrder(value);
  };

  return (
    <div className="pl-1 pr-1 sm:pr-6 min-h-screen">
      <div className="flex flex-wrap items-center gap-4 ml-4 mb-4">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="newest"
            checked={sortOrder === 1}
            onChange={() => handleSortChange(1)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Newest First</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="oldest"
            checked={sortOrder === 0}
            onChange={() => handleSortChange(0)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Oldest First</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="invalid"
            checked={sortOrder === 2}
            onChange={() => handleSortChange(2)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Invalid Orders</span>
        </label>
      </div>

      {orders.map((order, index) => (
        <OrderHeaderAccordion
          key={index}
          data={order}
          index={index}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
          onClose={() => {
            fetchData();
            setOpenIndex(null);
          }} />
      ))}

      <div className="flex flex-wrap justify-center items-center mt-4 mb-8 gap-2">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Previous
        </button>

        <button
          onClick={() => fetchData(1)}
          className={`px-4 py-2 border rounded ${currentPage === 1 ? "bg-blue-100" : ""
            }`}
        >
          1
        </button>

        {currentPage > 1 && (
          <button
            onClick={() => fetchData(currentPage)}
            className="px-4 py-2 border rounded bg-blue-100"
          >
            {currentPage}
          </button>
        )}

        <button
          onClick={handleNextPage}
          disabled={!hasNextPage}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
});

export default CheReceived;
